function PDFViewer() {
  const pdfURL =
    "http://localhost:5000/v1/filemanagers/files/66f9572544ccb947ab31b905_tthi.pdf";

  return (
    <div>
    
    </div>
  );
}
export default PDFViewer;
